import { IApplicationState, TReduxActions } from '../../types/redux';
import { IApplicationContext } from '../../types/application';
import { makeCreateStore } from '../../../../packages/redux-utils';
import { reducers } from '../../reducers';

export const createReduxStore = makeCreateStore<IApplicationState, IApplicationContext, TReduxActions>({
  name: 'feedback-frontend.FeedbackForm',
  reducer: reducers,
});
